import moment from "moment";
import {
  GET_BLOGS,
  GET_BLOGS_CATEGORY,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialBlogs = {
  blogs: [],
  categories: [],
  blogCount: 0,
  page: 1,
  search: "",
  orderby: -1,
  sortby: "",
};

function blogReducer(state = initialBlogs, action) {
  switch (action.type) {
    case GET_BLOGS:
      return {
        ...state,
        blogs: action.payload?.data?.blogs?.map((blog) => {
          return {
            ...blog,
            createdAt: moment(blog.createdAt).format("ll"),
          };
        }),
        blogCount: action.payload?.data?.total,
      };

    case GET_BLOGS_CATEGORY:
      return {
        ...state,
        categories: action.payload,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
}

export default blogReducer;
